import { api } from '..';
import parseResponse from './parseResponse';
export const requestMatch = (projectId, questionType = 'da') => parseResponse(api.carlos.requestMatch(projectId, questionType));
export const getMatchQueue = () => parseResponse(api.carlos.getMatchQueue());
export const getProjectHints = (projectId, questionType = 'da') => parseResponse(api.carlos.getProjectHints(projectId, questionType));
export const createAssignmentMatchHints = assignmentId => parseResponse(api.carlos.createAssignmentMatchHints(assignmentId));